export const NAME = 'Nightmare Market'; // the name of the app
// export const CONTRACT_ADDRESS = 'KT1QMNEEWF2NoBQtjA9v8cysiKGm6poHLkbj';
// export const RPC_URL = 'https://hangzhounet.smartpy.io'; // network rpc url

export const LIVE_PLAYER_CONTRACT_ADDRESS = 'KT1XMvvXa2ZRgnN7kZVmgNCkynbGXY4qqokb';
export const MARKET_CONTRACT_ADDRESS = 'nnnnnnnnnnnnnnnnnoooooooo';

//export const CONTRACT_ADDRESS = 'KT1BaCtLsB5WEXbTDhy74Ba7USJjZsT3KcHM';
//export const PLAYER_CONTRACT_ADDRESS = 'KT1BaCtLsB5WEXbTDhy74Ba7USJjZsT3KcHM';
export const CONTRACT_ADDRESS = 'KT1XMvvXa2ZRgnN7kZVmgNCkynbGXY4qqokb';
export const PLAYER_CONTRACT_ADDRESS = 'KT1XMvvXa2ZRgnN7kZVmgNCkynbGXY4qqokb';


// Our one
//export const LIVE_MARKET_CONTRACT_ADDRESS = 'KT1K2RYEUkkpAH7S95oxgT1F1qCvaEN6SGDs';
// Tezopunk X
// https://objkt.com/collection/KT1D3YwBbhDGpsvJi598qxMVy8Cs5fwRZtQf
export const LIVE_MARKET_CONTRACT_ADDRESS = 'KT1N2DpaCCiK9VyGcj7ohqN9AAQSQJe5oTKL';
// Xponentialdesign  - Versum
// https://objkt.com/profile/xponential/created?fa2=KT1LjmAdYQCLBjwv4S2oFkEzyHVkomAf5MrW - versum does not work !!
// https://objkt.com/collection/KT1LHW5ZmAQCCfQkcGQsAk8g5nAR2KwyDeCb
export const LIVE_MARKET_CONTRACT_ADDRESS2 = 'KT1A1roCqgNhmdUWgv6XTtNupHNxRcf7Dmty';


//export const RPC_URL = 'https://hangzhounet.api.tez.ie'; // network rpc url
export const RPC_URL = 'https://mainnet.api.tez.ie'; // network rpc url
export const LIVE_RPC_URL = 'https://mainnet.api.tez.ie'; // network rpc url


//export const NETWORK = 'hangzhounet';
export const NETWORK = 'mainnet';
export const LIVE_NETWORK = 'mainnet';